module.exports = __webpack_public_path__ + "static/img/1_5_2.696cf730.jpg";